<template>
  <div>
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <div class="vx-col w-full flex mb-4" id="account-manage-buttons">
      <vs-button
        v-if="user_data && !user_data.islockedafterinventory"
        icon-pack="feather"
        type="border"
        icon="icon-edit"
        class="mr-4"
        :to="{
          name: 'app-transport-edit',
          params: { userId: $route.params.userId },
        }"
        >Edit</vs-button
      >
    </div>
    <div id="user-data" v-if="user_data">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-4/12 w-full">
          <vx-card title="Transport" class="mb-base">
            <table>
              <!--<tr>
                <td class="font-semibold">Internal ID</td>
                <td>#{{ user_data.id }}</td>
              </tr>-->
              <tr>
                <td class="font-semibold">Active</td>
                <td>
                  <vs-chip v-if="user_data.isactive" color="primary">{{
                    user_data.isactive
                  }}</vs-chip>
                  <vs-chip v-else color="danger">{{
                    user_data.isactive
                  }}</vs-chip>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Transport date</td>
                <td>{{ format_date(user_data.date, false) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Create/Update</td>
                <td>
                  {{ format_date(user_data.createdAt, true) }} /
                  {{ format_date(user_data.updatedAt, true) }}
                </td>
              </tr>
            </table>
            <GmapMap
              :center="center"
              :zoom="4"
              map-type-id="terrain"
              style="width: 100%; height: 180px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m"
                :clickable="true"
                :draggable="false"
                @click="center = m"
              />
            </GmapMap>
          </vx-card>
        </div>

        <div class="vx-col lg:w-4/12 w-full">
          <vx-card v-if="user_data.people.length > 0" title="Transporter" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td v-if="user_data.people[0].iscompany">
                  <span>
                    <a href="#" @click="ViewPerson(user_data.people[0].id)">{{
                      user_data.people[0].company_name
                    }}</a>
                  </span>
                </td>
                <td v-else>
                  <span>
                    <a href="#" @click="ViewPerson(user_data.people[0].id)"
                      >{{ user_data.people[0].firstname }}
                      {{ user_data.people[0].lastname }}</a
                    >
                  </span>
                </td>
              </tr>
              <tr v-if="user_data.people[0].iscompany">
                <td class="font-semibold">VAT</td>
                <td>{{ user_data.people[0].vat_number }}</td>
              </tr>
              <tr v-if="user_data.people[0].email">
                <td class="font-semibold">Email</td>
                <td>{{ user_data.people[0].email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone</td>
                <td>{{ user_data.people[0].phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Address</td>
                <td>
                  <tr>
                    <vs-td>
                      <u>Billing</u>
                      <p v-if="addressbilling.province">
                        {{ addressbilling.street }} {{ addressbilling.nr }},
                        <br />
                        {{ addressbilling.cp }} {{ addressbilling.place }} ({{
                          addressbilling.province
                        }}),
                        <br />
                        {{ addressbilling.region }},
                        {{ addressbilling.country }}
                      </p>

                      <p v-else>
                        {{ addressbilling.street }} {{ addressbilling.nr }},
                        <br />
                        {{ addressbilling.cp }} {{ addressbilling.place }} ({{
                          addressbilling.region
                        }}),
                        <br />
                        {{ addressbilling.country }}
                      </p>
                    </vs-td>
                  </tr>
                </td>
              </tr>
              <tr v-if="user_data.driver">
                <td class="font-semibold">Driver</td>
                <td>{{ user_data.driver }}</td>
              </tr>
              <tr v-if="user_data.driver_phone">
                <td class="font-semibold">Driver Phone</td>
                <td>{{ user_data.driver_phone }}</td>
              </tr>
              <tr v-if="user_data.truck_plate">
                <td class="font-semibold">Truck Plate</td>
                <td>{{ user_data.truck_plate }}</td>
              </tr>
              <tr v-if="user_data.trailer_plate">
                <td class="font-semibold">Trailer Plate</td>
                <td>{{ user_data.trailer_plate }}</td>
              </tr>
              <tr v-if="dataTransitDate && user_data.transit_period">
                <td class="font-semibold">Delivery Date</td>
                <td>{{  format_date(dataTransitDate, false)  }} (Total transit of {{ user_data.transit_period }} days)</td>
              </tr>
              <tr>
                <td class="font-semibold">Transport Cost</td>
                <td>
                  {{
                    Math.abs(
                      user_data.products[0].operations_products.unit_price
                    )
                  }}
                  EUR
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Payment Status</td>
                <td v-if="user_data.salestatus && user_data.salestatus.name_en === 'Paid'">
                  <vs-chip color="success">{{ user_data.salestatus.name_en }}</vs-chip>
                </td>
                <td v-else-if="user_data.salestatus && user_data.salestatus.name_en === 'Cancelled'">
                  <vs-chip color="danger">{{ user_data.salestatus.name_en }}</vs-chip>
                </td>
                <td v-else-if="user_data.salestatus && user_data.salestatus.name_en === 'Pending'">
                  <vs-chip color="warning">{{ user_data.salestatus.name_en }}</vs-chip>
                </td>
                <td v-else>
                  <vs-chip color>{{ user_data.salestatus.name_en }}</vs-chip>
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-4/12 w-full mb-8">
          <vx-card title="Document">
            <!--
              Meme marchandise deux fois sur un meme camion. Avertissement, pas
              blocage : deux livraisons du meme produit peuvent etre legitimes.
            -->
            <vs-alert
              v-if="duplicateCheck && duplicateCheck.hasWarnings"
              :active="true"
              color="warning"
              icon-pack="feather"
              icon="icon-copy"
              class="mb-4"
            >
              <p class="mb-2">
                <strong>Marchandise potentiellement en double sur ce transport.</strong>
              </p>
              <ul>
                <li v-for="m in duplicateCheck.mergedOnBoard" :key="'m' + m.idquotation" class="mb-1">
                  Aviz {{ m.aviz_number }} (devis #{{ m.idquotation }}) a ete fusionne dans
                  #{{ m.idmergedinto }}, aussi sur ce transport : ses quantites y sont deja comptees.
                </li>
                <li v-for="o in duplicateCheck.productOverlaps" :key="'p' + o.idproduct" class="mb-1">
                  <strong>{{ o.produit }}</strong> sur {{ o.devis.length }} arrets du meme client
                  (devis {{ o.devis.join(', #') }}).
                </li>
              </ul>
            </vs-alert>
            <!--
              Echec de chargement != donnee incomplete : ce bandeau dit que l'API
              n'a pas repondu, cas ou les documents sortent blancs.
            -->
            <vs-alert
              v-if="dataLoadFailed"
              :active="true"
              color="danger"
              icon-pack="feather"
              icon="icon-wifi-off"
              class="mb-4"
            >
              <p class="mb-2">
                <strong
                  >Data could not be loaded from the server - documents will be blank or
                  incomplete.</strong
                >
              </p>
              <ul>
                <li v-for="err in loadErrors" :key="err.key" class="mb-1">
                  {{ err.label }}: <strong>{{ err.detail }}</strong>
                </li>
              </ul>
              <p class="mt-2">
                Reload the page. If it persists, this is a server-side error - send this message
                to the developer.
              </p>
            </vs-alert>
            <!--
              Un arret incomplet faisait planter la generation en lot sans aucun
              message. On liste tous les arrets fautifs avec le lien a corriger.
            -->
            <vs-alert
              v-if="documentsBlocked"
              :active="true"
              color="danger"
              icon-pack="feather"
              icon="icon-alert-triangle"
              class="mb-4"
            >
              <p class="mb-2">
                <strong>Documents cannot be generated - incomplete delivery data.</strong>
              </p>
              <ul>
                <li v-for="stop in incompleteStops" :key="stop.key" class="mb-1">
                  Aviz {{ stop.aviz }}: missing {{ stop.issues }}.
                  <router-link v-if="stop.link" :to="stop.link"
                    >Open {{ stop.linkLabel }} and set the delivery address</router-link
                  >
                </li>
              </ul>
            </vs-alert>
            <div id="data-list-list-view">
              <vs-button
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                @click="GenerateDocumentRO"
                >Transport Order (Linked with Quotation)
              </vs-button>

              <vs-button
                v-if="
                  user_data &&
                  user_data.products.length > 0 &&
                  routetransport.length > 0 &&
                  !documentsBlocked
                "
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                @click="GenerateDocumentCMR"
                >CMR (Linked with Final Invoice)
              </vs-button>
              <vs-button
                v-else
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                color="danger"
                @click="warnDocumentBlocked"
                >CMR ({{ documentBlockReason }})
              </vs-button>
              <vs-button
                v-if="
                  user_data &&
                  user_data.products.length > 0 &&
                  routetransport.length > 0 &&
                  !documentsBlocked
                "
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                @click="GenerateDocumentAviz"
                >AVIZ (Linked with Final Invoice)
              </vs-button>
              <vs-button
                v-else
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                color="danger"
                @click="warnDocumentBlocked"
                >AVIZ ({{ documentBlockReason }})
              </vs-button>
              <vs-button
                v-if="
                  user_data &&
                  user_data.products.length > 0 &&
                  routetransport.length > 0 &&
                  !documentsBlocked
                "
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                @click="GenerateDocumentReception"
                >RECEPTION (Linked with Final Invoice)
              </vs-button>
              <vs-button
                v-else
                icon-pack="feather"
                icon="icon-file"
                class="mr-4 mb-4 w-full"
                color="danger"
                @click="warnDocumentBlocked"
                >RECEPTION ({{ documentBlockReason }})
              </vs-button>
              <vs-table ref="table" :data="documents">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>{{ tr.name }}</vs-td>
                      <vs-td>
                        <a @click="downloadDocument(tr.url)">Download</a>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
            <div class="vx-col w-full flex mt-4" id="account-manage-buttons">
              <vs-button
                v-if="isConnect === 'true'"
                icon-pack="feather"
                type="border"
                icon="icon-file-text"
                class="mr-4"
                @click="activePrompt = true"
                >Add document</vs-button
              >
            </div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Linked Quotation" class="mb-base">
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table ref="table" :data="invoiceattached">
                  <template slot="thead">
                    <vs-th>#</vs-th>
                    <vs-th>Quotation</vs-th>
                    <vs-th>Client</vs-th>
                    <vs-th>Destination</vs-th>
                    <vs-th>Aviz Number</vs-th>
                    <vs-th>Action</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td>
                          <p class="font-medium truncate">
                            {{ indextr + 1 }}
                          </p>
                        </vs-td>

                        <vs-td>
                          <p class="font-medium truncate">REF #{{ tr.id }}</p>
                        </vs-td>

                        <vs-td>
                          <p>{{ tr.people }}</p>
                        </vs-td>

                        <vs-td>
                          <p>{{ tr.place_name }}, {{ tr.country }}</p>
                        </vs-td>

                        <vs-td>
                          <p>
                            Seria {{ tr.aviz_serie }}&nbsp;&nbsp; Nr.
                            {{ tr.aviz_number }}
                          </p>
                        </vs-td>
                        <vs-td class="whitespace-no-wrap"
                          ><feather-icon
                            icon="EyeIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click="OpenOperation(tr.id)"
                        /></vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-prompt
      @cancel="clearValMultiple"
      @accept="acceptAlert"
      @close="closePrompt"
      :is-valid="validName"
      :active.sync="activePrompt"
    >
      <input
        type="file"
        id="fil"
        color="warning"
        ref="fil"
        v-on:change="uploadFile()"
        hidden
      />
      <vs-button
        v-if="isConnect === 'true'"
        id="file"
        ref="file"
        @click="$refs.fil.click()"
        style="width: 100%"
        >Upload</vs-button
      >
      <vs-input
        v-if="isConnect === 'true'"
        label="Document Name"
        v-model="dataDocumentName"
        class="mt-5 w-full"
        name="document"
        v-validate="'required'"
      />
      <vs-input
        v-if="isConnect === 'true'"
        label="URL"
        v-model="urlDocument"
        class="mt-5 w-full"
        name="url"
        v-validate="'required'"
        disabled
      />
      <span class="text-danger text-sm" v-show="errors.has('url')">{{
        errors.first("url")
      }}</span>
    </vs-prompt>

    <vs-prompt
      :active.sync="activePrompt1"
      @cancel="closePrompt1"
      @accept="closePrompt1"
      @close="closePrompt1"
    >
      <p
        v-if="isLoading"
        style="
          margin-top: 30px;
          margin-bottom: 30px;
          text-align: center;
          font-size: 150%;
        "
      >
        Loading, please wait...
      </p>
      <div
        id="results"
        style="
          margin-top: 30px;
          margin-bottom: 30px;
          text-align: center;
          font-size: 150%;
        "
      ></div>
    </vs-prompt>
  </div>
</template>

<script>
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import axios from "@/axios.js";

import documentTotals from "@/mixins/documentTotals.js";
import routeStopGuard from "@/mixins/routeStopGuard.js";
import documentDataLoad from "@/mixins/documentDataLoad.js";
import { normalizeAddress, hasAddress, addressOneLine, drawAddressBlock, fromPersonAddress, parseRouteAddress, routeStopFields } from "@/helpers/address.js";
import { isFirewoodProduct } from "@/helpers/firewood.js";
import { AVIZ_FIREWOOD_LOADING_LINE, AVIZ_INCOTERM_LABEL, isDepartureIncoterm } from "@/helpers/firewoodDeclaration.js";
export default {
  mixins: [documentTotals, routeStopGuard, documentDataLoad],
  data() {
    return {
      dataTransitDate:null,
      user_data: null,
      user_not_found: false,
      productlist: [],
      dataOperations: [],
      documents: [],
      activePrompt: false,
      activePrompt1: false,
      backgroundLoading: "primary",
      colorLoading: "#fff",
      dataDocumentName: null,
      dataDropBoxKey: "",
      isConnect: "false",
      urlDocument: null,
      isLoading: true,
      data_currency: null,
      routetransport: [],
      routetransportfromquotation: [],
      cmrproduct: [],
      duplicateCheck: null,
      allowCMR: true,
      addressdelivery: {},
      addressbilling: {},
      invoiceattached: null,
      markers: [],
      center: { lat: 50.0, lng: 12.0 },
    };
  },
  computed: {
    validName() {
      return this.dataDocumentName && this.urlDocument;
    },
    userAddress() {
      let str = "";
      for (const field in this.user_data.address) {
        str += `${field} `;
      }
      return str;
    },
  },
  methods: {
    updateDeliveryDate() {
      var start = moment(this.user_data.date).add(this.user_data.transit_period, "days");
      this.dataTransitDate = moment(start).toString("YYYY-MM-DD");
    },
    async getBillingAndDeliveryAddressListDetails() {
      {
        axios
          .get(
            "/person/getaddressbillingdetails/" +
              this.user_data.id +
              "/" +
              this.$route.params.userId
          )
          .then((response) => {
            this.addressbilling = normalizeAddress(response.data[0]);
          });
      }
    },
    ViewPerson(id) {
      this.$router.push({ path: "/person/" + id });
    },
    closePrompt1() {
      this.isLoading = true;
    },
    // Avertissement doublons (transportcheck.controller.js). Silencieux si l'API
    // echoue : c'est un filet, pas une donnee du document.
    async getDuplicateCheck() {
      return axios
        .get("/transport/" + this.user_data.id + "/duplicatecheck")
        .then((response) => { this.duplicateCheck = response.data; })
        .catch((error) => { console.error("duplicatecheck:", error); });
    },
    async getCMRproduct() {
      // Le try/catch autour d'une promesse n'attrape rien : le rejet vivait dans
      // la chaine et partait en unhandled rejection, totalement invisible.
      return axios
        .get("/getcmrtransportv2/" + this.user_data.id)
        .then((response) => {
          this.cmrproduct = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.cmrproduct = [];
          this.reportLoadError("cmrproduct", "Transported goods (reception lines)", error);
        });
    },
    async getRouteTransport() {
      // Le try/catch autour d'une promesse n'attrape rien : sur erreur API la
      // liste restait telle quelle. On force un tableau.
      return axios
        .get("/getroutetransportv2/" + this.user_data.id)
        .then((response) => {
          this.routetransport = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.routetransport = [];
          this.reportLoadError("routetransport", "Transport stops (route, addresses, aviz)", error);
        });
    },
    async getRouteTransportFromQuotation() {
      return axios
        .get("/getroutetransportv3/" + this.user_data.id)
        .then((response) => {
          this.routetransportfromquotation = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.routetransportfromquotation = [];
          this.reportLoadError("routetransportfromquotation", "Quotation stops", error);
        });
    },
    async getDropBoxData() {
      try {
        axios.get("/dropbox/").then((response) => {
          this.dataDropBoxKey = response.data.key;
          this.connectToDropBox();
        });
      } catch (error) {}
    },
    downloadDocument(urldocument) {
      try {
        this.activePrompt1 = true;
        var dropboxV2Api = require("dropbox").Dropbox;
        var dbx = new dropboxV2Api({ accessToken: this.dataDropBoxKey, fetch });
        dbx
          .filesDownload({
            path: urldocument,
          })
          .then((response) => {
            var downloadUrl = URL.createObjectURL(response.fileBlob);
            var downloadButton = document.createElement("a");
            downloadButton.setAttribute("href", downloadUrl);
            downloadButton.setAttribute("download", response.name);
            downloadButton.setAttribute("class", "button");
            downloadButton.innerText = "Download: " + response.name;
            document.getElementById("results").appendChild(downloadButton);
            this.isLoading = false;
          });
      } catch (error) {}
    },
    uploadFile() {
      try {
        this.file = this.$refs.fil.files[0];
        this.dataDocumentName = this.file.name;
        var dropboxV2Api = require("dropbox").Dropbox;
        var dbx = new dropboxV2Api({ accessToken: this.dataDropBoxKey, fetch });
        this.urlDocument =
          "/operations/" + this.user_data.id + "/" + this.file.name;
        dbx
          .filesUpload({
            path: "/operations/" + this.user_data.id + "/" + this.file.name,
            contents: this.file,
          })
          .then((response) => {
            var dropboxV2Api = require("dropbox").Dropbox;
            var dbx = new dropboxV2Api({
              accessToken: this.dataDropBoxKey,
              fetch,
            });
            dbx
              .sharingCreateSharedLink({
                path: "/operations/" + this.user_data.id + "/" + this.file.name,
              })
              .then((response) => {
                /*var pathdl = response.url.split("?");
              var pathdownload = pathdl[0] + "&dl=1";
              this.urlDocument = pathdownload;*/
              })
              .catch(function (error) {
                console.error(error);
              });
          });
      } catch (error) {}
    },
    acceptAlert() {
      let obj = {};
      obj = {
        url: this.urlDocument,
        name: this.dataDocumentName,
        idoperation: this.user_data.id,
      };
      axios.post("/document/create", obj).then((response) => {
        this.getDocument();
      });
      this.$vs.notify({
        color: "success",
        title: "Document Uploaded!",
        text: "The Document was successfully Updated",
      });
    },
    getDocument() {
      axios
        .get(`/document/${this.user_data.id}`)
        .then((response) => {
          this.documents = response.data;
        })
        .catch((error) => {});
    },
    connectToDropBox() {
      this.isConnect = "false";
      var dropboxV2Api = require("dropbox").Dropbox;
      var _path = null;
      var dbx = new dropboxV2Api({ accessToken: this.dataDropBoxKey, fetch });
      dbx
        .filesListFolder({ path: "" })
        .then((response) => {
          this.isConnect = "true";
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    closePrompt() {
      this.clearValMultiple();
    },
    clearValMultiple() {
      this.dataDocumentName = "";
      this.urlDocument = "";
    },
    OpenOperation(id) {
      this.$router.push({ path: "/quotation/" + id });
    },
    getProductListPdf() {
      // Lignes ET totaux dans le meme aller-retour : le montant imprime est la
      // somme des lignes du document.
      return this.fetchDocumentLines(this.$route.params.userId, "1");
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    moment: function () {
      return moment();
    },
    async GenerateDocumentRO() {
      // Garde-fou : lignes + totaux rechargés ET attendus. Aucun document n'est
      // produit si le montant imprimé n'est pas la somme des lignes.
      try {
        await this.getProductListPdf();
        this.assertDocumentConsistent(this.productlist, this.documentTotals, {
          idoperation: this.$route.params.userId,
          documentLabel: "#" + this.$route.params.userId,
        });
      } catch (guardErr) {
        if (this.$vs && this.$vs.loading) this.$vs.loading.close();
        this.reportDocumentTotalsError(guardErr, {
          idoperation: this.$route.params.userId,
        });
        return;
      }
      var img_stamp =
        "data:image/png;base64,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";
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      /*doc.text(140, 10, "Generated At " + this.format_date(Date(), true));
      doc.text(140,15,"Operation Date " + this.format_date(this.user_data.date, false));*/
      doc.setLineWidth(0.5);
      doc.line(10, 10, 200, 10); // horizon top
      doc.line(10, 10, 10, 156); // vertical left
      doc.line(10, 156, 200, 156); // horizon down
      doc.line(200, 10, 200, 156); // vertical right

      // TITRE
      doc.setFontSize(14);
      doc.text(
        65,
        20,
        "COMANDA DE TRANSPORT: " +
          moment(this.user_data.date).format("YYYYMMDD")
      );
      doc.line(10, 27, 200, 27); // séparation title
      doc.setLineWidth(0.1);
      // EXPEDITOR
      doc.setFontSize(12);
      doc.text(20, 35, "Expeditor / Beneficiar transport: ");
      doc.text(80, 35, "XYLO IMPACT SRL ");
      doc.text(160, 35, "CIF RO 33531190");
      doc.text(160, 40, "J2022000979207");
      doc.setFontSize(10);
      doc.text(80, 45, "Strada Principala 115A, Teiu 337291, Romania");
      doc.line(10, 50, 200, 50); // séparation expéditor
      // TRANSPORTEUR
      doc.setFontSize(12);
      doc.text(20, 57, "Caraus: ");
      if (this.user_data.people && this.user_data.people.length > 0)
      {
      if (this.user_data.people[0].iscompany) {
        doc.text(80, 57, this.user_data.people[0].company_name);
        if (this.user_data.people[0].vat_number)
          doc.text(160, 57, this.user_data.people[0].vat_number);
      } else
        doc.text(
          80,
          57,
          this.user_data.people[0].firstname +
            " " +
            this.user_data.people[0].lastname
        );
      }
      doc.setFontSize(10);
      if (hasAddress(this.addressbilling)) {
        doc.text(
          80,
          67,
          addressOneLine(this.addressbilling)
        );
      } else doc.text(80, 67, "Address: NO DATA");

      doc.line(10, 72, 200, 72); // séparation transporteur
      // AUTO
      doc.setFontSize(12);
      doc.text(20, 79, "Auto: ");
      if (this.user_data.truck_plate) doc.text(80, 79, this.user_data.truck_plate);
      doc.line(10, 84, 200, 84); // séparation AUTO
      // SOFER
      doc.text(20, 91, "Sofer: ");
      if (this.user_data.driver) doc.text(80, 91, this.user_data.driver);
      doc.setLineWidth(0.5);
      doc.line(10, 96, 200, 96); // séparation SOFER
      doc.setLineWidth(0.1);
      // RUTA DE TRANSPORT
      doc.text(20, 103, "Ruta de transport: ");
      if ( this.routetransportfromquotation &&  this.routetransportfromquotation.length > 0)
      {
      // One row per quotation now, so the category has to be read from EVERY
      // row: it used to arrive as a comma-joined aggregate on row [0].
      var directionTeiu = this.routetransportfromquotation.some((r) =>
        String(r.idcategory || "")
          .split(",")
          .some((c) => c.trim() == 1 || c.trim() == 6)
      );
      }
      doc.setFontSize(7);
      if (directionTeiu) {
        let Routeee = "";
        this.routetransportfromquotation.forEach((value, index) => {
          if (value.route) Routeee = Routeee + "   =>   " + value.route;
        });

        doc.text(80, 103, Routeee + "   337291 Teiu, Romania");
      } else {
        let Routeee = "";
        this.routetransportfromquotation.forEach((value, index) => {
          if (value.route) Routeee = Routeee + "   =>   " + value.route;
        });
        doc.text(80, 103, "337291 Teiu, Romania   " + Routeee);
      }
      doc.setFontSize(12);
      doc.line(10, 108, 200, 108); // séparation RUTA DE TRANSPORT
      // TARIF
      doc.text(20, 115, "Tarif de transport: ");
      doc.text(
        80,
        115,
        Math.abs(
          this.docTotalHtEur
        ).toFixed(2) + " EUR+TVA"
      );
      /*doc.text(
        130,
        115,
        "(1EUR = " + parseFloat(this.data_currency).toFixed(2) + "RON)"
      );*/
      doc.setLineWidth(0.5);
      doc.line(10, 120, 200, 120); // séparation RUTA DE TARIF
      doc.setLineWidth(0.1);
      // FELUL MARFII
      doc.text(20, 127, "Felul marfii: ");
      doc.setFontSize(7);
      doc.text(
        80,
        127,
        "[ ] Stalpi din lemn paletizat      [ ] Stalpi din lemn nepaletizat      [ ] Lemn Rotund"
      );
      doc.setFontSize(12);
      doc.line(10, 132, 200, 132); // séparation FELUL MARFII
      // PLATA SE VA
      doc.text(20, 139, "Plata se va efectua la: ");
      doc.text(80, 139, "Prin OP dupa descarcare");
      doc.line(10, 144, 200, 144); // PLATA SE VA // DATA DESCA // TERMEN TRANSIT
      // DATA INCARAC
      doc.text(
        20,
        151,
        "Termen tranzit: "
      );
      doc.text(80, 151, this.user_data.transit_period + " ZILE");
      doc.line(10, 156, 200, 156); // DATA DESCA

      // TABLE INCARCARE
      doc.setLineWidth(0.5);
      doc.line(10, 166, 200, 166); // horizon top
      doc.line(10, 166, 10, 285); // vertical left
      doc.line(10, 285, 200, 285); // horizon down
      doc.line(200, 166, 200, 285); // vertical right
      doc.setLineWidth(0.1);

      if (directionTeiu) {
        // incaracari
        doc.setFontSize(14);
        doc.text(20, 173, "Incarcarii");
        doc.setFontSize(12);
        doc.text(20, 180, "Data:");
        doc.text(80, 180, moment(this.user_data.date).format("DD/MM/YYYY"));
        doc.text(20, 185, "Locul incarcarii: ");
        // `addresstranport` was never declared anywhere: this branch threw a
        // ReferenceError and the whole "Locul incarcarii" block was lost.
        const loadingStops = this.routetransportfromquotation || [];
        const numberedLoading = loadingStops.length > 1;
        loadingStops.forEach((value, index) => {
          const [adresse, societe] = routeStopFields(value.addresses);
          const prefix = numberedLoading ? index + 1 + "." : "";
          doc.text(80, 185 + index * 15, prefix + societe);
          doc.text(80, 190 + index * 15, adresse);
        });
        doc.line(10, 225.5, 200, 225.5); // separation incaracarii descarcarii
        // DESCARACARI
        doc.setFontSize(14);
        doc.text(20, 232.5, "Descarcarii");
        doc.setFontSize(12);
        doc.text(20, 239.5, "Data:");
        if (this.user_data.transit_period) {
          doc.text(
            80,
            239.5,
            moment(this.user_data.date)
              .add(parseInt(this.user_data.transit_period), "days")
              .format("DD/MM/YYYY")
          );
        } else {
          doc.text(80, 239.5, "Necunoscut");
        }
        doc.text(20, 244.5, "Locul descarcarii: ");
        doc.text(80, 244.5, "337291 TEIU, jud. Hunedoara, Romania");
        doc.text(20, 264.5, "Contact:");
        doc.text(80, 264.5, "Clément Vandenplas\n0040 752 06 14 51");
      } else {
        // incaracari
        doc.setFontSize(14);
        doc.text(20, 173, "Incarcarii");
        doc.setFontSize(10);
        doc.text(20, 180, "Data:");
        doc.text(80, 180, moment(this.user_data.date).format("DD/MM/YYYY"));
        doc.text(20, 185, "Locul incarcarii: ");
        doc.text(80, 185, "337291 TEIU, jud. Hunedoara, Romania");
        doc.text(20, 190, "Contact:");
        doc.text(80, 190, "Clément Vandenplas\n0040 752 06 14 51");
        doc.line(10, 200, 200, 200); // separation incaracarii descarcarii
        // DESCARACARI
        doc.setFontSize(14);
        doc.text(20, 207, "Descarcarii");
        doc.setFontSize(10);
        doc.text(20, 214, "Data:");
        doc.text(
          80,
          213,
          moment(this.user_data.date)
            .add(parseInt(this.user_data.transit_period), "days")
            .format("DD/MM/YYYY")
        );
        doc.text(20, 219, "Locul descarcarii: ");
        if (this.routetransportfromquotation.length > 1) {
          /*addresstranport.forEach((value, index) => {
            var diviseuraddresscontact = value.split("@");
            doc.text(
              80,
              244.5 + index * 15,
              index + 1 + "." + diviseuraddresscontact[1]
            );
            doc.text(80, 249.5 + index * 15, diviseuraddresscontact[0]);
          });*/

          this.routetransportfromquotation.forEach((value, index) => {
            const [adresse, societe] = routeStopFields(value.addresses);
            doc.text(80, 219 + index * 13, index + 1 + "." + societe);
            doc.text(80, 224 + index * 13, adresse);
          });
        } else {
          this.routetransportfromquotation.forEach((value, index) => {
            const [adresse, societe] = routeStopFields(value.addresses);
            doc.text(80, 219 + index * 13, societe);
            doc.text(80, 224 + index * 13, adresse);
          });
        }
      }
      doc.addImage(img_stamp, "JPEG", 160, 250, 42, 32);
      doc.addPage();
      doc.text(
        20,
        20,
        "Art. 1 CONDITII GENERALE DE TRANSPORT:\na) Raspunderea civila a carausului ce transporta marfuri pe teritoriul UE 50.000 euro;\nb) Transbordarea este interzisa fara acceptul Expeditorului; Carausul isi asuma raspunderea pentru integritatea marfurilor\ntransportate, pe toata durata transportului, pana la predarea lor destinatarului;\nc) Depasirea sarcinii maxime autorizate pe osie este in sarcina Carausului;\nd) Intarzierile nejustificate la incarcare, descarcare, tranzit se penalizeaza cu 150 €/zi;\ne) Comanda poate fi anulata de catre Expeditor, intr-un interval mai mic de 24 de ore, inainte de data si ora stabilite pentru\nexpediere, cu plata unei penalitati catre Caraus de 400 de lei.\n\n\nArt.2 CARAUSUL se obliga:\na) Sa presteze serviciile de transport in conditiile convenite, conform specificatiilor expeditorului si la pretul stabilit\nprin comanda;\nb) Sa ia in primire marfurile conform specificatiilor expeditorului, iar daca are rezerve privind starea marfurilor, trebuie\nsa le mentioneze in mod expres, in momentul incarcarii marfii in camion. In caz contrar se va prezuma ca marfa\ntransportata nu prezinta vicii;\nc) Sa predea marfurile, la destinatie, la termenul convenit prin comanda;\nd) Sa-si asume raspunderea pentru integritatea marfurilor transportate, pe toata duratatransportului, pana la predarea\nlor destinatarului;\ne) Sa suporte costul asigurarii transportului, avand obligatia sa suporte totodata contravaloarea eventualelor lipsuri sau\npierderi inregistrate, produse din culpa sa;\nf) Factura de transport trebuie sa fie insotita de: comanda de transport, factura/avize de insotire marfaconfirmate,\nprocese verbale confirmate, alte documente specificate in comanda si va fi transmisa la sediul punctului de lucru\nin cel mult 7 zile calendaristice de la efectuarea transportului;\ng) Delegatul transportatorului (soferul) va asista la incarcarea mijlocului de transport. Transportatorul are obligatia\nsa consilieze expeditorul, sa supravegheze si sa verifice modul de incarcare al marfii, astfel incat sa fie in concordanta\ncu prevederile legale si apoi sa asigure marfa, prin verificarea sistemelor de fixare a acesteia in interiorul mijlocului\nde transport, pentru a nu exista incidente in timpul transportului din cauza modului de incarcare al marfii.\nRaspunderea cu privire la marfa este integrala a transportatorului in cazul oricaror prejudicii produse marfii,\ntransportatorului sau tertilor ca urmare a incarcarii necorespunzatoare a marfii.\n\n\nArt.3 EXPEDITORUL se obliga:\na) Sa plateasca tariful de transport convenit la termenele convenite.  In cazul nerespectarii Art.2 f,\nfactura va fi returnata si vina va apartine exclusiv Carausului."
      );
      doc.text(20, 200, "CONFIRMARE CU SEMNATURA SI STAMPILA\nBENEFICIAR,");
      doc.addImage(img_stamp, "JPEG", 40, 195, 42, 32);
      doc.text(140, 200, "CARAUS,");
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
          "_" +
          this.user_data.operationcategory.name_en +
          "_" +
          this.user_data.id +
          ".pdf"
      );
    },
    GenerateDocumentReception() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");

      for (let i = 0; i < this.routetransport.length; i++) {
        if (i !== 0) doc.addPage();
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        var strtitre=null
        var strfurnizor = null
        var strsediul = null
        var strpunctdelucru= null
        var strtransport = null
        var strdestinatar = null
        var strspecificatia = null
        var strprodusambalajetc=null
        var strproduslungimediametruperimetru = null
        var strcantitate = null
        var strfacturascopuri=null
        var strdindatade = null
        var strprinsemareablabla = null
        var strnumeledestinarului = null
        var strtva = null
        var stridentitateapersoanelorcare = null
        var strdata=null
        var strsemnatura = null

        if (diviseuraddresscontact[4] == "2")
        {
            //FR
            strtitre = "Déclaration de réception des marchandises"
            strfurnizor = "Fournisseur"
            strsediul = "Siège social"
            strpunctdelucru = "Poste de travail"
            strtransport = "Transport"
            strdestinatar = "Destinataire"
            strspecificatia = "Spécification"
            strprodusambalajetc = "(Produits, emballages, etc.)"
            strproduslungimediametruperimetru = "Produit (L = Longueur ; d = Diamètre ; P = Périmètre)"
            strcantitate = "Montant"
            strfacturascopuri = "Facture / Objectifs"
            strdindatade = "Daté du"
            strprinsemareablabla = "En signant cette Déclaration de Réception de Marchandises, le Destinataire reconnaît avoir reçu tous les produits\nmentionnés dans le tableau ci-dessus."
            strnumeledestinarului = "Nom du destinataire:"
            strtva = "T.V.A:"
            stridentitateapersoanelorcare = "Identité des personnes acceptant les marchandises :"
            strdata = "Date:"
            strsemnatura = "Signature"

        }
        else if (diviseuraddresscontact[4] == "3")
        {
            //RO
            strtitre = "Declarația privind primirea bunurilor"
            strfurnizor = "Furnizor"
            strsediul = "Sediul"
            strpunctdelucru = "Punct de lucru"
            strtransport = "Transport"
            strdestinatar = "Destinatar"
            strspecificatia = "Specificatia"
            strprodusambalajetc="(Produse, ambalaje, etc.)"
            strproduslungimediametruperimetru = "Produs (L = Lungime; d = diametru; P = Perimetru)"
            strcantitate = "Cantitate"
            strfacturascopuri="Factura/Scopuri"
            strdindatade = "Din data de "
            strprinsemareablabla = "Prin semnarea acestei Declarații de Primire a Bunurilor, Destinatarul recunoaște că a primit toate produselor\nmentionate in tabelul de mai sus."
            strnumeledestinarului = "Numele Destinatarului: "
            strtva = "TVA:"
            stridentitateapersoanelorcare = "Identitatea persoanelor care accept bunurile: "
            strdata="Data: "
            strsemnatura = "Semnatura"
        }
        else if (diviseuraddresscontact[4] == "4")
        {
            //DE
            strtitre = "Wareneingangserklärung"
            strfurnizor = "Anbieter"
            strsediul = "Hauptquartier"
            strpunctdelucru = "Arbeitsplatz"
            strtransport = "Transport"
            strdestinatar = "Empfänger"
            strspecificatia = "Spezifikation"
            strprodusambalajetc = "(Produkte, Verpackungen usw.)"
            strproduslungimediametruperimetru = "Produkt (L = Länge; d = Durchmesser; P = Umfang)"
            strcantitate = "Menge"
            strfacturascopuri = "Rechnung"
            strdindatade = "Zeitpunkt"
            strprinsemareablabla = "Mit der Unterzeichnung dieser Wareneingangserklärung bestätigt der Empfänger, dass er alle in der obigen Tabelle\naufgeführten Produkte erhalten hat."
            strnumeledestinarului = "Name des Empfängers:"
            strtva = "Mehrwertsteuer:"
            stridentitateapersoanelorcare = "Identität der Personen, die die Ware annehmen:"
            strdata = "Datum:"
            strsemnatura = "Unterschrift"

        }
        else if (diviseuraddresscontact[4] == "5")
        {
            //ES
            strtitre = "Declaración de recepción de mercancías"
            strfurnizor = "proveedor"
            strsediul = "sede"
            strpunctdelucru = "Puesto de trabajo"
            strtransport = "Transporte"
            strdestinatar = "Consignatario"
            strspecificatia = "Especificación"
            strprodusambalajetc = "(Productos, envases, etc.)"
            strproduslungimediametruperimetru = "Producto (L = Longitud; d = Diámetro; P = Perímetro)"
            strcantitate = "Monto"
            strfacturascopuri = "Factura / Propósitos"
            strdindatade = "Fecha"
            strprinsemareablabla = "Al firmar esta Declaración de Recepción de Mercancías, el Destinatario reconoce que ha recibido todos los productos\nmencionados en la tabla anterior."
            strnumeledestinarului = "Nombre del destinatario:"
            strtva = "IVA:"
            stridentitateapersoanelorcare = "Identidad de las personas que aceptan las mercancías:"
            strdata = "Fecha:"
            strsemnatura = "Firma"
        }
        else if (diviseuraddresscontact[4] == "6")
        {
            //NL
            strtitre = "Verklaring van ontvangst van goederen"
            strfurnizor = "aanbieder"
            strsediul = "hoofdkwartier"
            strpunctdelucru = "Werkstation"
            strtransport = "Vervoer"
            strdestinatar = "Geadresseerde"
            strspecificatia = "Specificatie"
            strprodusambalajetc = "(Producten, verpakkingen, enz.)"
            strproduslungimediametruperimetru = "Product (L = lengte; d = diameter; P = omtrek)"
            strcantitate = "Hoeveelheid"
            strfacturascopuri = "Factuur / doeleinden"
            strdindatade = "Vanaf"
            strprinsemareablabla = "Door deze verklaring van ontvangst van goederen te ondertekenen, erkent de ontvanger dat hij alle producten heeft\nontvangen die in de bovenstaande tabel worden vermeld."
            strnumeledestinarului = "Naam ontvanger:"
            strtva = "VAT:"
            stridentitateapersoanelorcare = "Identiteit van de personen die de goederen in ontvangst nemen:"
            strdata = "Datum:"
            strsemnatura = "Handtekening"
        }
        else
        {
            //EN
            strtitre = "Declaration of receipt of goods"
            strfurnizor = "Provider"
            strsediul = "headquarters"
            strpunctdelucru = "Workstation"
            strtransport = "Transport"
            strdestinatar = "Consignee"
            strspecificatia = "Specification"
            strprodusambalajetc = "(Products, packaging, etc.)"
            strproduslungimediametruperimetru = "Product (L = Length; d = Diameter; P = Perimeter)"
            strcantitate = "Amount"
            strfacturascopuri = "Invoice / Purposes"
            strdindatade = "dated"
            strprinsemareablabla = "By signing this Declaration of Receipt of Goods, the Recipient acknowledges that he has received all the\nproducts mentioned in the table above."
            strnumeledestinarului = "Recipient's name:"
            strtva = "VAT:"
            stridentitateapersoanelorcare = "Identity of persons accepting the goods:"
            strdata = "Date:"
            strsemnatura = "Signature"
        }
        doc.setFontType("bold");
        doc.setFontSize(10);
        doc.text(
          10,
          10,
          "Seria " +
            this.routetransport[i].aviz_serie +
            "  nr. " +
            this.routetransport[i].aviz_number
        );
        doc.text(80, 10, strtitre);
        doc.text(
          174,
          10,
          strdata+" " + moment(this.routetransport[i].date).format("DD/MM/YYYY")
        );
        doc.setFontType("normal");

        doc.setLineWidth(0.5);
        doc.line(10, 20, 200, 20); // horizon top
        doc.line(10, 20, 10, 75); // vertical left
        doc.line(200, 20, 200, 75); // vertical right
        doc.line(10, 75, 200, 75); // horizon down
        doc.line(73.33, 20, 73.33, 75); // vertical midleft
        doc.line(136.67, 20, 136.67, 75); // vertical midright

        // UNLOADING CONTACT
        doc.line(10, 82, 200, 82); // horizon down
        doc.line(10, 75, 10, 82); // vertical left
        doc.line(200, 75, 200, 82); // vertical right
        doc.setFontType("bold");
        doc.setFontSize(12);
        doc.text(13, 80, "Contact de descarcare/Unloading Contact:");
        doc.setFontType("italic");
        doc.setFontSize(10);
        doc.text(92, 80, "Mariana Nagy (Tel: +40 752 170 031)");
        doc.setFontType("normal");

        // FUNIZOR
        doc.setFontSize(14);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(13, 26, strfurnizor+":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(13, 31, "SC XYLO IMPACT SRL");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);

        doc.text(13, 35, "TVA: RO33531190");
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(13, 43, strsediul);
        doc.setFontType("normal");
        doc.text(13, 47, "Strada Principala 115A,");
        doc.text(13, 51, "Teiu 337291,");
        doc.text(13, 55, "Jud. Hunedoara (Romania)");
        doc.setFontType("bold");
        doc.text(13, 61, strpunctdelucru);
        doc.setFontType("normal");
        doc.text(13, 65, "Sat TEIU, Com. Lapugiu de Jos,");
        doc.text(13, 69, "Jud. Hunedoara (Romania)");

        // TRANSPORTER
        doc.setFontSize(14);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(76.33, 26, strtransport+":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(12);
        if (this.user_data.people[0].iscompany) {
          doc.setFontSize(9);
          doc.setFontType("bold");
      doc.setFont("Amiri");
          doc.text(76.33, 31, this.user_data.people[0].company_name);
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
          doc.text(76.33, 35, strtva+" " + this.user_data.people[0].vat_number);
        } else {
          doc.setFontSize(9);
          doc.setFontType("bold");
      doc.setFont("Amiri");
          doc.text(
            76.33,
            31,
            this.user_data.people[0].firstname +
              " " +
              this.user_data.people[0].lastname
          );
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
        }

        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 76.33, 43, 4);
        } else doc.text(76.33, 43, "Address: NO DATA");
        // DESTINATAR
        doc.setFontSize(14);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(139.67, 26, strdestinatar+":");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(139.67, 31, diviseuraddresscontact[1]);
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.text(139.67, 35, diviseuraddresscontact[2]);
        // `addressLine1/2` : la 2e ligne pouvait etre undefined sur une adresse
        // sans virgule, et jsPDF plantait.
        var stopaddress = parseRouteAddress(this.routetransport[i].addresses);
        doc.text(139.67, 43, (stopaddress.addressLine1 || "-") + ",");
        doc.text(139.67, 47, stopaddress.addressLine2 || "");

        // PRODUIT
        doc.setFontSize(14);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.text(13, 93, strspecificatia+":");
        doc.setFontType("italic");
        doc.setFontSize(12);
        doc.text(13, 98, strprodusambalajetc);
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setLineWidth(0.5);
        doc.line(10, 100, 200, 100); // horizon top
        doc.line(10, 100, 10, 190); // vertical left
        doc.line(200, 100, 200, 190); // vertical right
        doc.line(10, 190, 200, 190); // horizon down
        doc.line(170, 100, 170, 190); // vertical midright
        doc.setFontSize(9);
        doc.setFontType("bold");
      doc.setFont("Amiri");
        doc.setLineWidth(0.1);
        doc.text(12, 105, "CRT");
        doc.line(20, 100, 20, 190); // vertical 1
        doc.text(23, 105, strproduslungimediametruperimetru);
        doc.line(137, 100, 137, 190); // vertical 3
        doc.text(140, 105, strcantitate);
        doc.text(173, 105, strfacturascopuri);
        doc.line(10, 108, 200, 108); // horizon top
        doc.setFontType("normal");
      doc.setFont("Amiri");

        // PRODUCT!!!
        let z = 0;
        doc.setFont("Amiri");
        let sumQuantity = 0;
        let sumVolume = 0;
        this.cmrproduct.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != 'Services')
            {
            z++;
            doc.text(12, 110 + z * 5, z.toString());
            doc.text(
              23,
              110 + z * 5,
              value.name
            );
            //doc.text(23, 110 + z * 5, value.category_ro+"/"+value.name);
            //doc.text(120, 110 + z * 5, value.quantity + " " + value.uom);
            //doc.text(140, 120 + z * 5, value.category);
            //doc.text(140, 110 + z * 5, value.volume + " m3");
            sumQuantity = sumQuantity + parseFloat(value.quantity);
            sumVolume = sumVolume + parseFloat(value.volume);
            doc.text(140, 110 + z * 5, value.quantity + " " + value.uom);
            if (z == 1) doc.text(171, 110 + z * 5, value.invoice_no);
            doc.setFontSize(7);
            if (z == 1) doc.text(171, 113 + z * 5, "("+strdindatade+ " "+value.date+")");
            doc.setFontSize(9);
            }
          }
        });
        doc.text(140, 113 + z * 5, "------------");
        doc.text(140, 116 + z * 5, "Total pcs : " + sumQuantity + " Pcs");
        doc.text(
          140,
          119 + z * 5,
          "Total vol.: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );

        // TEXT BOTTOM
        doc.setFontSize(10);
      doc.setFont("Amiri");
        doc.setFontType("italic");
        doc.text(
          13,
          205,
          strprinsemareablabla
        );

        doc.text(
          13,
          225,
         strnumeledestinarului+" "+diviseuraddresscontact[1]
        );

        doc.text(
          13,
          235,
          strtva+" "+diviseuraddresscontact[3]
        );

        doc.text(
          13,
          245,
          stridentitateapersoanelorcare
        );
        doc.text(
          13,
          255,
          strdata
        );
        doc.text(
          13,
          265,
          strsemnatura
        );

      }

      // SAVER
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
          "_declaratiaPrivindPrimireaBunurilor_" +
          this.user_data.operationcategory.name_en +
          "_" +
          this.user_data.id +
          ".pdf"
      );
    },
    GenerateDocumentAviz() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");

      for (let i = 0; i < this.routetransport.length; i++) {
        if (i !== 0) doc.addPage();
        doc.setFontType("bold");
        doc.setFontSize(10);
        doc.text(
          10,
          10,
          "Seria " +
            this.routetransport[i].aviz_serie +
            "  nr. " +
            this.routetransport[i].aviz_number
        );
        doc.text(80, 10, "AVIZ DE INSOTIRE A MARFII");
        doc.text(
          174,
          10,
          "Data: " + moment(this.routetransport[i].date).format("DD/MM/YYYY")
        );
        doc.setFontType("normal");

        doc.setLineWidth(0.5);
        doc.line(10, 20, 200, 20); // horizon top
        doc.line(10, 20, 10, 75); // vertical left
        doc.line(200, 20, 200, 75); // vertical right
        doc.line(10, 75, 200, 75); // horizon down
        doc.line(73.33, 20, 73.33, 75); // vertical midleft
        doc.line(136.67, 20, 136.67, 75); // vertical midright

        // UNLOADING CONTACT
        doc.line(10, 82, 200, 82); // horizon down
        doc.line(10, 75, 10, 82); // vertical left
        doc.line(200, 75, 200, 82); // vertical right
        doc.setFontType("bold");
        doc.setFontSize(12);

        doc.text(13, 80, "Contact de descarcare/Unloading Contact:");
        doc.setFontType("italic");
        doc.setFontSize(10);
        doc.text(92, 80, "Mariana Nagy (Tel: +40 752 170 031)");
        doc.setFontType("normal");

        // FUNIZOR
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(13, 26, "Furnizor:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(13, 31, "SC XYLO IMPACT SRL");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);

        doc.text(13, 35, "TVA: RO33531190");
        doc.setFontType("bold");
        doc.text(13, 43, "Sediul: ");
        doc.setFontType("normal");
        doc.text(13, 47, "Strada Principala 115A,");
        doc.text(13, 51, "Teiu 337291,");
        doc.text(13, 55, "Jud. Hunedoara (Romania)");
        doc.setFontType("bold");
        doc.text(13, 61, "Punct de lucru: ");
        doc.setFontType("normal");
        doc.text(13, 65, "Sat TEIU, Com. Lapugiu de Jos,");
        doc.text(13, 69, "Jud. Hunedoara (Romania)");

        // TRANSPORTER
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(76.33, 26, "Transport:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(12);
        if (this.user_data.people[0].iscompany) {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.text(76.33, 31, this.user_data.people[0].company_name);
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
          doc.text(76.33, 35, "TVA: " + this.user_data.people[0].vat_number);
        } else {
          doc.setFontSize(9);
          doc.setFontType("bold");
          doc.text(
            76.33,
            31,
            this.user_data.people[0].firstname +
              " " +
              this.user_data.people[0].lastname
          );
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(9);
        }

        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 76.33, 43, 4);
        } else doc.text(76.33, 43, "Address: NO DATA");
        // DESTINATAR
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(139.67, 26, "Destinatar:");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(139.67, 31, diviseuraddresscontact[1]);
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setFontSize(9);
        doc.text(139.67, 35, diviseuraddresscontact[2]);
        // `addressLine1/2` : la 2e ligne pouvait etre undefined sur une adresse
        // sans virgule, et jsPDF plantait.
        var stopaddress = parseRouteAddress(this.routetransport[i].addresses);
        doc.text(139.67, 43, (stopaddress.addressLine1 || "-") + ",");
        doc.text(139.67, 47, stopaddress.addressLine2 || "");

        // PRODUIT
        doc.setFontSize(14);
        doc.setFontType("bold");
        doc.text(13, 93, "Specificatia:");
        doc.setFontType("italic");
        doc.setFontSize(12);
        doc.text(13, 98, "(Produse, ambalaje, etc.)");
        doc.setFontType("normal");
        doc.setFont("Amiri");
        doc.setLineWidth(0.5);
        doc.line(10, 100, 200, 100); // horizon top
        doc.line(10, 100, 10, 190); // vertical left
        doc.line(200, 100, 200, 190); // vertical right
        doc.line(10, 190, 200, 190); // horizon down
        doc.line(170, 100, 170, 190); // vertical midright
        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.setLineWidth(0.1);
        doc.text(12, 105, "CRT");
        doc.line(20, 100, 20, 190); // vertical 1
        doc.text(23, 105, "Produs (L = Lungime; d = diametru; P = Perimetru)");
        //doc.line(117, 100, 117, 190); // vertical 2
        //doc.text(120, 105, "Cantitate");
        //doc.line(137, 100, 137, 190); // vertical 3
        //doc.text(140, 105, "Volum Total (m3)");

        doc.line(137, 100, 137, 190); // vertical 3
        doc.text(140, 105, "Cantitate");

        doc.text(173, 105, "Factura/Scopuri");
        doc.line(10, 108, 200, 108); // horizon top
        doc.setFontType("normal");

        // PRODUCT!!!
        let z = 0;
        doc.setFont("Amiri");
        let sumQuantity = 0;
        let sumVolume = 0;
        this.cmrproduct.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != 'Services')
            {
            z++;
            doc.text(12, 110 + z * 5, z.toString());
            doc.text(
              23,
              110 + z * 5,
              value.name.replace(value.category, value.category_ro)
            );
            //doc.text(23, 110 + z * 5, value.category_ro+"/"+value.name);
            //doc.text(120, 110 + z * 5, value.quantity + " " + value.uom);
            //doc.text(140, 120 + z * 5, value.category);
            //doc.text(140, 110 + z * 5, value.volume + " m3");
            sumQuantity = sumQuantity + parseFloat(value.quantity);
            sumVolume = sumVolume + parseFloat(value.volume);
            doc.text(140, 110 + z * 5, value.quantity + " " + value.uom);
            if (z == 1) doc.text(171, 110 + z * 5, value.invoice_no);
            doc.setFontSize(7);
            if (z == 1) doc.text(171, 113 + z * 5, "(Din data de "+value.date+")");
            doc.setFontSize(9);
            }
          }
        });
        doc.text(140, 113 + z * 5, "------------");
        doc.text(140, 116 + z * 5, "Total pcs : " + sumQuantity + " Pcs");
        doc.text(
          140,
          119 + z * 5,
          "Total vol.: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );

        // TEXT BOTTOM
        // Facture bois de chauffage (lemn de foc) : le paragraphe « nu sunt
        // materiale lemnoase (STALPI...) » serait faux, on l'omet. A sa place
        // (Ferdinand, 2026-10-09) : le terme de livraison et, seulement si le
        // client transporte lui-meme (FCA / EXW), la mention « charge a la demande
        // du client » avec le chauffeur / la plaque repris du transport, a completer
        // a la main quand ils manquent. Une livraison DAP par transporteur n'a
        // que le terme. Les avize poteaux ne changent pas.
        const firewoodLines = this.cmrproduct.filter(
          (v) => v.id === this.routetransport[i].id && isFirewoodProduct(v.idproduct)
        );
        if (firewoodLines.length > 0) {
          doc.setFontType("normal");
          doc.setFont("Amiri");
          doc.setFontSize(10);
          const inco = this.routetransport[i].incoterms
            ? this.routetransport[i].incoterms +
              (this.routetransport[i].incoterms_dest
                ? " - " + this.routetransport[i].incoterms_dest
                : "")
            : "";
          if (inco) doc.text(13, 200, AVIZ_INCOTERM_LABEL + inco);
          if (isDepartureIncoterm(this.routetransport[i].incoterms)) {
            doc.setFontType("bold");
            doc.text(13, 210, AVIZ_FIREWOOD_LOADING_LINE);
            doc.setFontType("normal");
            doc.setFont("Amiri");
            doc.setFontSize(10);
            const plates = [this.user_data.truck_plate, this.user_data.trailer_plate]
              .filter((x) => x && String(x).trim())
              .join(" / ");
            doc.text(13, 220, "Nume sofer: " + (this.user_data.driver || "________________________"));
            doc.text(105, 220, "Nr. inmatriculare: " + (plates || "____________________"));
            doc.text(13, 230, "Semnatura sofer: ________________________");
          }
        } else {
          doc.setFontSize(10);
          doc.setFontType("italic");
          doc.text(
            13,
            210,
            "Produsele ce fac obiectul prezentei facturi nu sunt “materiale lemnoase” astfel cum sunt acestea definite la pct. 21 din Anexa la\nLegea nr. 46/2008 (modificata) pentru aprobarea Codului Silvic si nu fac obiectul prevederilor Regulamentului (UE) nr. 995/2010\nal Parlamentului European si al Consiliului, intrucat costituie produse finite (STALPI decojiti, ascutiti, paletizate, parafinate),\nsi circula in acord cu regulile UE privind circulatia marfurilor in Comunitatea Europeana."
          );
        }

        // SEMNATURA
        doc.setFontSize(10);
        doc.setFontType("normal");
        doc.text(13, 250, "Semnatura si stampila\nfurnizorului:");
        doc.text(67, 250, "Am incarcat\n(nume, prenume, semnatura):");
        doc.text(136, 250, "Am verificat\n(nume, prenume, semnatura):");
      }

      // SAVER
      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
          "_AVIZ_" +
          this.user_data.operationcategory.name_en +
          "_" +
          this.user_data.id +
          ".pdf"
      );
    },
    GenerateDocumentCMR() {
      if (this.warnDocumentBlocked()) return;
      const doc = new jsPDF();
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setLineWidth(0.5);
      for (let i = 0; i < this.routetransport.length; i++) {
        if (i !== 0) doc.addPage();
        doc.line(10, 10, 200, 10); // horizon top
        doc.line(10, 10, 10, 285); // vertical left
        doc.line(10, 285, 200, 285); // horizon down
        doc.line(200, 10, 200, 285); // vertical right

        doc.line(105, 10, 105, 135); // vertical middle

        // FIRST ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 15, "1.");
        doc.setFontSize(6);
        doc.text(17, 15, "Sender (name, address, country)");
        doc.setFontSize(8);
        doc.text(17, 20, "XYLO IMPACT SRL (VAT: RO33531190)");
        doc.text(17, 24, "Strada Principala 115A,");
        doc.text(17, 28, "337291 Teiu,");
        doc.text(17, 32, "Jud. Hunedoara, Romania");
        // FIRST ROW // RIGHT
        doc.setFontSize(12);
        doc.text(112, 20, "INTERNATIONAL CONSIGNMENT NOTE");
        doc.setFontSize(16);
        doc.text(112, 30, "CMR");
        doc.setFontSize(8);
        doc.text(
          130,
          27,
          "This carriage is subject notwithstanding any clause to the\ncontrary, to the Convention on the Contract for the\nInternational Carriage of goods by road (CMR)"
        );
        doc.line(10, 40, 200, 40); // END FIRST ROW
        // SECOND ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 45, "2.");
        doc.setFontSize(6);
        doc.text(17, 45, "Consignee (name, address, country)");
        doc.setFontSize(8);
        /*addresstranport.forEach((value, index) => {
          var diviseuraddresscontact = value.split("@");
          doc.text(25, 50 + index * 8, diviseuraddresscontact[1]);
          doc.text(25, 53 + index * 8, diviseuraddresscontact[0]);
        });*/
        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);

        //25 à 17
        doc.text(17, 50 + 0 * 8, diviseuraddresscontact[1]);
        doc.text(17, 53 + 0 * 8, diviseuraddresscontact[0]);

        // SECOND ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 45, "16.");
        doc.setFontSize(6);
        doc.text(116, 45, "Carrier (name, address, country)");
        doc.setFontSize(8);

        // TRANSPORTEUR
        if (this.user_data.people[0].iscompany) {
          if (this.user_data.people[0].vat_number)
            doc.text(
              116,
              50,
              this.user_data.people[0].company_name +
                "(" +
                this.user_data.people[0].vat_number +
                ")"
            );
          else doc.text(116, 50, this.user_data.people[0].company_name);
        } else
          doc.text(
            116,
            50,
            this.user_data.people[0].firstname +
              " " +
              this.user_data.people[0].lastname
          );
        if (this.user_data.people[0].addresses[0]) {
          drawAddressBlock(doc, fromPersonAddress(this.user_data.people[0].addresses[0]), 116, 54, 4);
        } else doc.text(116, 54, "Address: NO DATA");
        doc.line(10, 70, 200, 70); // END SECOND ROW
        // THIRD ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 75, "3.");
        doc.setFontSize(6);
        doc.text(17, 75, "Place of delivery of the goods (place, country)");
        doc.setFontSize(8);

        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        doc.text(17, 80 + 0 * 4, diviseuraddresscontact[0]);

        /*addresstranport.forEach((value, index) => {
          var diviseuraddresscontact = value.split("@");
          doc.text(25, 80 + index * 4, diviseuraddresscontact[0]);
        });*/
        // THIRD ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 75, "17.");
        doc.setFontSize(6);
        doc.text(116, 75, "Successive Carriers (name, address, country)");
        doc.setFontSize(8);
        doc.line(10, 95, 200, 95); // END THRID ROW
        // FOURTH ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 100, "4.");
        doc.setFontSize(6);
        doc.text(
          17,
          100,
          "Place of and date of taking over the goods (place, country, date)"
        );
        doc.setFontSize(8);
        doc.text(17, 105, "DC 137, 337284 SAT TEIU,");
        doc.text(17, 109, "LAPUGIU DE JOS, HUNDEDOARA, ROMANIA");
        doc.text(17, 113, moment(this.user_data.date).format("DD/MM/YYYY"));
        // FOURTH ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 100, "18.");
        doc.setFontSize(6);
        doc.text(116, 100, "Carrier's reservations and observations");
        doc.setFontSize(8);
        doc.text(116, 105, "Carrier's name: " + this.user_data.driver);
        doc.text(116, 109, "Carrier's phone: " + this.user_data.driver_phone);
        doc.text(116, 113, "Truck plate: " + this.user_data.truck_plate);
        doc.text(116, 117, "Trailer plate: " + this.user_data.trailer_plate);

        doc.line(10, 120, 105, 120); // END FOURTH ROW

        // FIFTH ROW LEFT
        doc.setFontSize(16);
        doc.text(12, 125, "5.");
        doc.setFontSize(6);
        doc.text(17, 125, "Documents attached");
        doc.setFontSize(8);
        doc.text(
          17,
          129,
          "Aviz de insotire a marfii:    Seria " +
            this.routetransport[i].aviz_serie +
            "   Nr." +
            this.routetransport[i].aviz_number
        );
        doc.setFontSize(6);
        doc.setFontSize(8);
        doc.line(10, 135, 200, 135); // horizon middle
        // SIXTH ROW LEFT
        doc.setFontSize(14);
        doc.text(12, 140, "6.");
        doc.setFontSize(6);
        doc.text(17, 140, "Marks and Nos");
        doc.setFontSize(14);
        doc.text(32, 140, "7.");
        doc.setFontSize(6);
        doc.text(37, 140, "Number of packages");
        doc.setFontSize(14);
        doc.text(62, 140, "8.");
        doc.setFontSize(6);
        doc.text(67, 140, "Method of packaging");
        doc.setFontSize(14);
        doc.text(92, 140, "9.");
        doc.setFontSize(6);
        doc.text(97, 140, "Nature of the goods");
        doc.setFontSize(14);
        doc.text(122, 140, "10.");
        doc.setFontSize(6);
        doc.text(129, 140, "Statistical number");
        doc.setFontSize(14);
        doc.text(147, 140, "11.");
        doc.setFontSize(6);
        doc.text(154, 140, "Gross weight in kg");
        doc.setFontSize(14);
        doc.text(177, 140, "12.");
        doc.setFontSize(6);

        doc.setFontSize(8);
        let z = 0;

        let sumQuantity = 0;
        let sumVolume = 0;
        this.cmrproduct.forEach((value, index) => {
          if (value.id === this.routetransport[i].id) {
            if (value.category != 'Services')
            {
            z++;
            doc.text(17, 142 + z * 5, value.name);
            doc.text(129, 142 + z * 5, value.quantity + " " + value.uom);
            //doc.text(37, 150 + index * 8, value.quantity + " " + value.uom);
            let vl = value.category.split("(");
            doc.text(97, 142 + z * 5, vl[0]);
            sumQuantity = sumQuantity + parseFloat(value.quantity);
            sumVolume = sumVolume + parseFloat(value.volume);
            // doc.text(178, 142 + z * 5, value.volume + " m3");
            }
          }
        });
        doc.text(
          170,
          142 + 1 * 5,
          "Total: " + parseFloat(sumVolume).toFixed(2) + " m3"
        );
        doc.line(10, 190, 200, 190); // horizon middle
        // SEV ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 195, "13.");
        doc.setFontSize(6);
        doc.text(21, 195, "Sender Instruction");
        doc.setFontSize(8);
        doc.text(21, 199, "Unloading Contact:");

        var diviseuraddresscontact = routeStopFields(this.routetransport[i].addresses);
        doc.text(21, 203, "Ferdinand Terlinden +32 473 233 33");
        doc.text(21, 207, diviseuraddresscontact[1]);

        // SEV ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 195, "19.");
        doc.setFontSize(6);
        doc.text(116, 195, "Special Agreements");
        doc.line(10, 220, 200, 220); // END SEV ROW
        doc.setFontSize(16);
        doc.text(12, 225, "14.");
        doc.setFontSize(6);
        doc.text(21, 225, "Instructions as to payment for carriage");
        doc.setFontSize(8);
        doc.text(25, 230, "[] Carrage paid        [] Carrage forward");
        // 8 ROW // LEFT
        doc.line(10, 235, 200, 235); // END SEV ROW
        doc.setFontSize(16);
        doc.text(12, 240, "21.");
        doc.setFontSize(6);
        doc.text(21, 240, "Established in");
        doc.setFontSize(8);
        doc.text(
          25,
          245,
          "TEIU, ROMANIA   " +
            moment(this.user_data.date).format("DD MMMM YYYY")
        );
        // 8 ROW // RIGHT
        doc.setFontSize(16);
        doc.text(107, 225, "20.");
        doc.setFontSize(6);
        doc.text(
          116,
          225,
          "To be paid by (Carriage charges, deductions, balance, sup. charges, other charges)"
        );
        doc.line(105, 190, 105, 250); // vertical middle
        doc.line(10, 250, 200, 250); // END 8 ROW
        doc.setFontSize(16);
        doc.text(107, 240, "15.");
        doc.setFontSize(6);
        doc.text(116, 240, "Cash on delivery");
        // 9 ROW // LEFT
        doc.setFontSize(16);
        doc.text(12, 255, "22.");
        doc.setFontSize(6);
        doc.text(21, 255, "Signature and stamp of the sender");
        doc.line(70, 250, 70, 285); // vertical middle
        // 9 ROW // MID
        doc.setFontSize(16);
        doc.text(72, 255, "23.");
        doc.setFontSize(6);
        doc.text(81, 255, "Signature and stamp of the carrier");
        doc.line(140, 250, 140, 285); // vertical middle
        // 9 ROW // RIGHT
        doc.setFontSize(16);
        doc.text(142, 255, "24.");
        doc.setFontSize(6);
        doc.text(151, 255, "Signature and stamp of the consignee");
        doc.line(105, 190, 105, 250); // vertical middle
      }

      doc.save(
        +moment(this.user_data.date).format("YYYYMMDD") +
          "_CMR_" +
          this.user_data.operationcategory.name_en +
          "_" +
          this.user_data.id +
          ".pdf"
      );
    },
    ViewCompany() {
      window.location.replace("/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    async fetch_invoice_linked_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchInvoiceLinked", userId)
          .then((res) => {
            this.invoiceattached = res.data;
            this.markers = res.data;
          });
      } else {
        this.invoiceattached = {};
      }
    },
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    const userId = this.$route.params.userId;
    this.fetch_invoice_linked_data(userId);
    this.getProductListPdf();
    this.$store
      .dispatch("operationList/fetchOperation", userId)
      .then((res) => {
        this.user_data = res.data;
        this.updateDeliveryDate();
        this.getDocument();
        this.getDropBoxData();
        this.getRouteTransport();
        this.getRouteTransportFromQuotation();
        this.getCMRproduct();
        this.getDuplicateCheck();
        this.getBillingAndDeliveryAddressListDetails();
        //this.GenerateDocumentReception()

        if (this.user_data.operationcategory.id === 7) {
          this.$store
            .dispatch(
              "operationList/fetcheurdifference",
              this.$route.params.userId
            )
            .then((res) => {
              //this.m3difference = res;
              //console.log(this.$store.state.operationList.m3difference)
            })
            .catch((err) => {
              if (err.response.status === 404) {
                this.user_not_found = true;
                return;
              }
              console.error(err);
            });
        } else {
          this.$router.push({ path: "/pages/error-404" });
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      })
      .then((res) => {
      });
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}
/*
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}*/

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
